interface LogoProps {
  className?: string;
}

export default function Logo({ className = "h-9" }: LogoProps) {
  return (
    <img
      src="https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/0c134db6-0a40-4fe0-8abd-1e6022c18560_compressed_voxmaster-logo21-1.webp"
      alt="Voxmaster LLC — Wholesale VoIP Carrier"
      className={`${className} w-auto object-contain`}
    />
  );
}